<div
    [formGroup]="quickAccessForm"
    [ngClass]="{ 'disable-favorite': onDisableFavorite | async }"
    fxLayout="row"
    class="quick-access-wrapper"
    fxLayoutAlign="start start"
>
    <ng-container *ngIf="authUser$ | async; let authUser">
        <app-quick-access-platform-listing
            *ngIf="!!metadata?.user_quick_links?.length"
            class="auth-wrapper"
            [user]="user"
            [customer]="customer"
            [icon]="'person'"
            [title]="AppScope.getScopeLabel(authCustomer$, AppScope.USERS) | async"
            [quickAccessData]="metadata?.user_quick_links"
            [formArrayName]="'user_quick_links'"
            context="au"
            [onDisableFavorite]="onDisableFavorite"
            [onDisableShortlisted]="onDisableShortlisted"
        ></app-quick-access-platform-listing>
        <app-quick-access-platform-listing
            *ngIf="authUser.isAdmin() && !!metadata?.admin_quick_links?.length"
            [user]="user"
            [customer]="customer"
            class="auth-wrapper"
            [icon]="'people_alt'"
            title="Admin"
            i18n-title
            context="admin"
            [quickAccessData]="metadata?.admin_quick_links"
            [formArrayName]="'admin_quick_links'"
            [onDisableFavorite]="onDisableFavorite"
            [onDisableShortlisted]="onDisableShortlisted"
        ></app-quick-access-platform-listing>
        <app-quick-access-platform-listing
            *ngIf="authUser.isMasterAdmin() && !!metadata?.master_quick_links?.length"
            [user]="user"
            [customer]="customer"
            class="auth-wrapper"
            [icon]="'account_balance'"
            title="Master"
            i18n-title
            context="master"
            [quickAccessData]="metadata?.master_quick_links"
            [formArrayName]="'master_quick_links'"
            [onDisableFavorite]="onDisableFavorite"
            [onDisableShortlisted]="onDisableShortlisted"
        ></app-quick-access-platform-listing>
    </ng-container>
</div>
